import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type LabelPlacement = 'left' | 'right' | 'top';

export type FormFieldProps = {
  label?: React.ReactNode;
  invalid?: boolean;
  labelPlacement?: LabelPlacement;
  error?: React.ReactNode;
  help?: React.ReactNode;
  disabled?: boolean;
  children: React.ReactNode;
} & React.LabelHTMLAttributes<HTMLLabelElement>;

const classNamePrefix = `airtame-form-field`;

export const FormField = ({
  label,
  invalid,
  labelPlacement = 'top',
  className,
  error,
  help,
  disabled,
  children,
  ...props
}: FormFieldProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(
    className,
    classNamePrefix,
    `${classNamePrefix}--label-${labelPlacement}`,
    {
      [`${classNamePrefix}--disabled`]: disabled,
      [`${classNamePrefix}--invalid`]: !disabled && invalid,
    }
  );

  return (
    <label className={classNames} data-theme={theme} {...props}>
      {label && <span className={`${classNamePrefix}__label`}>{label}</span>}
      <div className={`${classNamePrefix}__input-wrapper`}>{children}</div>
      {(error || help) && (
        <div className={`${classNamePrefix}__meta`}>
          {help && <div className={`${classNamePrefix}__hint`}>{help}</div>}
          {error && <div className={`${classNamePrefix}__error`}>{error}</div>}
        </div>
      )}
    </label>
  );
};

FormField.displayName = 'FormField';
